/**
 * Copyright Highway9 Networks Inc.
 */
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Dataset from "@mui/icons-material/Dataset";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RefreshIcon from "@mui/icons-material/Refresh";
import VideocamIcon from "@mui/icons-material/Videocam";
import StorageIcon from "@mui/icons-material/Storage";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import VerticalAlignTop from "@mui/icons-material/VerticalAlignTop";
import AccessTime from "@mui/icons-material/AccessTime"
import AccessTimeOutlined from "@mui/icons-material/AccessTimeOutlined"
import AccountCircleRounded from "@mui/icons-material/AccountCircleRounded"
import AccountTree from "@mui/icons-material/AccountTree"
import Add from "@mui/icons-material/Add"
import AddCircle from "@mui/icons-material/AddCircle"
import AlarmOff from "@mui/icons-material/AlarmOff"
import AlarmOn from "@mui/icons-material/AlarmOn"
import ArrowCircleDown from "@mui/icons-material/ArrowCircleDown"
import ArrowCircleUp from "@mui/icons-material/ArrowCircleUp"
import ArrowDownward from "@mui/icons-material/ArrowDownward"
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos"
import ArrowUpward from "@mui/icons-material/ArrowUpward"
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn"
import AutoDelete from "@mui/icons-material/AutoDelete"
import AvTimer from "@mui/icons-material/AvTimer"
import CancelRounded from "@mui/icons-material/CancelRounded"
import CellTowerIcon from "@mui/icons-material/CellTower"
import CheckCircle from "@mui/icons-material/CheckCircle"
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded"
import Circle from "@mui/icons-material/Circle"
import CloudUploadRounded from "@mui/icons-material/CloudUploadRounded"
import CodeOutlined from "@mui/icons-material/CodeOutlined"
import ConnectWithoutContact from "@mui/icons-material/ConnectWithoutContact"
import ContentCopy from "@mui/icons-material/ContentCopy"
import CrisisAlert from "@mui/icons-material/CrisisAlert"
import DashboardRounded from "@mui/icons-material/DashboardRounded"
import DataObject from "@mui/icons-material/DataObject"
import DatasetOutlined from "@mui/icons-material/DatasetOutlined"
import DeleteForever from "@mui/icons-material/DeleteForever"
import DeleteSweep from "@mui/icons-material/DeleteSweep"
import DeveloperMode from "@mui/icons-material/DeveloperMode"
import DeviceHub from "@mui/icons-material/DeviceHub"
import DevicesRounded from "@mui/icons-material/DevicesRounded"
import DnsOutlined from "@mui/icons-material/DnsOutlined"
import DragIndicator from "@mui/icons-material/DragIndicator"
import EqualizerRounded from "@mui/icons-material/EqualizerRounded"
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded"
import ExploreOutlined from "@mui/icons-material/ExploreOutlined"
import FiberManualRecord from "@mui/icons-material/FiberManualRecord"
import Fullscreen from "@mui/icons-material/Fullscreen"
import GroupWorkRounded from "@mui/icons-material/GroupWorkRounded"
import HeightRounded from "@mui/icons-material/HeightRounded"
import HikingOutlined from "@mui/icons-material/HikingOutlined"
import Home from "@mui/icons-material/Home"
import HomeRepairService from "@mui/icons-material/HomeRepairService"
import Info from "@mui/icons-material/Info"
import InfoOutlined from "@mui/icons-material/InfoOutlined"
import InfoTwoTone from "@mui/icons-material/InfoTwoTone"
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined"
import Input from "@mui/icons-material/Input"
import Label from "@mui/icons-material/Label"
import LabelOff from "@mui/icons-material/LabelOff"
import Leaderboard from "@mui/icons-material/Leaderboard"
import LeakAdd from "@mui/icons-material/LeakAdd"
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined"
import LocationOnRounded from "@mui/icons-material/LocationOnRounded"
import ManageHistoryRounded from "@mui/icons-material/ManageHistoryRounded"
import Mediation from "@mui/icons-material/Mediation"
import Memory from "@mui/icons-material/Memory"
import MenuBookRounded from "@mui/icons-material/MenuBookRounded"
import ModeStandbyOutlinedIcon from "@mui/icons-material/ModeStandbyOutlined"
import MoveDown from "@mui/icons-material/MoveDown"
import MoveUp from "@mui/icons-material/MoveUp"
import MultipleStop from "@mui/icons-material/MultipleStop"
import NotificationsOff from "@mui/icons-material/NotificationsOff"
import OnlinePrediction from "@mui/icons-material/OnlinePrediction"
import OpenInBrowserRounded from "@mui/icons-material/OpenInBrowserRounded"
import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined"
import PhoneIphone from "@mui/icons-material/PhoneIphone"
import Public from "@mui/icons-material/Public"
import RememberMe from "@mui/icons-material/RememberMe"
import ReportProblemTwoTone from "@mui/icons-material/ReportProblemTwoTone"
import Save from "@mui/icons-material/Save"
import SensorsSharp from "@mui/icons-material/SensorsSharp"
import SettingsInputAntenna from "@mui/icons-material/SettingsInputAntenna"
import ShoppingCartRounded from "@mui/icons-material/ShoppingCartRounded"
import SimCard from "@mui/icons-material/SimCard"
import SupportAgent from "@mui/icons-material/SupportAgent"
import TapAndPlay from "@mui/icons-material/TapAndPlay"
import TimerRounded from "@mui/icons-material/TimerRounded"
import TipsAndUpdates from "@mui/icons-material/TipsAndUpdates"
import TipsAndUpdatesOutlined from "@mui/icons-material/TipsAndUpdatesOutlined"
import Topic from "@mui/icons-material/Topic"
import TrackChangesOutlined from "@mui/icons-material/TrackChangesOutlined"
import TroubleshootOutlined from "@mui/icons-material/TroubleshootOutlined"
import TuneRounded from "@mui/icons-material/TuneRounded"
import UpdateOutlined from "@mui/icons-material/UpdateOutlined"
import Visibility from "@mui/icons-material/Visibility"
import Webhook from "@mui/icons-material/Webhook"
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded"
import WifiTethering from "@mui/icons-material/WifiTethering"
import MonitorIcon from '@mui/icons-material/Monitor';
import UploadIcon from "@mui/icons-material/Upload";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
import EmailIcon from "@mui/icons-material/Email";
import TimelineIcon from "@mui/icons-material/Timeline";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PersonIcon from "@mui/icons-material/Person";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from "@mui/icons-material/Delete";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import PageviewIcon from "@mui/icons-material/Pageview";
import GroupIcon from "@mui/icons-material/Group";
import CloudIcon from "@mui/icons-material/Cloud";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import LanguageIcon from "@mui/icons-material/Language";
import BuildIcon from "@mui/icons-material/Build";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotesIcon from "@mui/icons-material/Notes";
import EditIcon from "@mui/icons-material/Edit";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import Crop169Icon from "@mui/icons-material/Crop169";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import PasswordIcon from "@mui/icons-material/Password";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import Folder from "@mui/icons-material/Folder";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CloseIcon from "@mui/icons-material/Close";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PlaceIcon from "@mui/icons-material/Place";
import DvrIcon from "@mui/icons-material/Dvr";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberSmartRecordIcon from "@mui/icons-material/FiberSmartRecord";
import HistoryIcon from "@mui/icons-material/History";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ExtensionIcon from "@mui/icons-material/Extension";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import AdjustIcon from "@mui/icons-material/Adjust";
import RestartAlt from "@mui/icons-material/RestartAlt";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import InstallMobileRoundedIcon from "@mui/icons-material/InstallMobileRounded";
import SystemSecurityUpdateRoundedIcon from "@mui/icons-material/SystemSecurityUpdateRounded";
import PhonelinkSetupRoundedIcon from "@mui/icons-material/PhonelinkSetupRounded";
import SystemSecurityUpdateGoodRoundedIcon from "@mui/icons-material/SystemSecurityUpdateGoodRounded";
import AppBlockingRoundedIcon from "@mui/icons-material/AppBlockingRounded";
import DeviceUnknownRoundedIcon from "@mui/icons-material/DeviceUnknownRounded";
import SystemSecurityUpdateWarningRoundedIcon from "@mui/icons-material/SystemSecurityUpdateWarningRounded";
import TimerIcon from "@mui/icons-material/Timer";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import { OBJ_STATUS } from "../constants";
import { asset } from "../assets";
import SensorsIcon from "@mui/icons-material/Sensors";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SupportIcon from "@mui/icons-material/Support";
import Engineering from "@mui/icons-material/Engineering";
import AddToHomeScreen from "@mui/icons-material/AddToHomeScreen";
import Tune from "@mui/icons-material/Tune";
import SatelliteIcon from '@mui/icons-material/Satellite';
import SatelliteIconAlt from '@mui/icons-material/SatelliteAlt';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Gradient from "@mui/icons-material/Gradient";
import StackedBarChart from "@mui/icons-material/StackedBarChart";
import TableView from "@mui/icons-material/TableView";
import { text } from "./TextResources";
import CodeIcon from '@mui/icons-material/Code';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Search from "@mui/icons-material/Search";
import BroadcastOnPersonalIcon from '@mui/icons-material/BroadcastOnPersonal';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MapIcon from '@mui/icons-material/Map';
import SecurityIcon from '@mui/icons-material/Security';
import CategoryIcon from '@mui/icons-material/Category';
import DevicesIcon from '@mui/icons-material/Devices';
import DescriptionIcon from '@mui/icons-material/Description';
import Radio, { OperationalState } from "~/types/radio";
import { Hardware } from "~/types/Hardware";
import LensOutlinedIcon from '@mui/icons-material/LensOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import EmergencySvg from "~/assets/emergancySvg";
import IndoorRadioGroup from "~/assets/indoorRadioGroup";
import OutdoorRadioGroup from "~/assets/outdoorRadioGroup";
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import SimCardOutlinedIcon from '@mui/icons-material/SimCardOutlined';
import DoneIcon from '@mui/icons-material/Done';
import OutputIcon from '@mui/icons-material/Output';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MobilityEdge from "~/assets/MobilityEdge";
import Network from "~/assets/Network";
import NetworkArrowRight from "~/assets/NetworkArrowRight";
import CheckCircleOverflown from "~/assets/CheckCirleOverflown";
import DownloadInstall from "~/assets/DownloadInstall";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AboutRadioGeneral from "~/assets/AboutRadioGeneral";
import AboutRadioCellNFrequency from "~/assets/AboutRadioCellNFrequency";
import AboutRadioSAS from "~/assets/AboutRadioSAS";
import AboutRadioMobility from "~/assets/AboutRadioMobility";
import AboutRadioAdvanced from "~/assets/AboutRadioAdvanced";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ArrowCircleUpTwoTone from '@mui/icons-material/ArrowCircleUpTwoTone';
import HealingIcon from "@mui/icons-material/Healing";
import BuildCircleOutlined from "@mui/icons-material/BuildCircleOutlined";
import HeadsetMic from "@mui/icons-material/HeadsetMic";
import Help from "@mui/icons-material/Help";
import CheckIcon from "@mui/icons-material/Check";
import ReportIcon from "@mui/icons-material/Report";
import WarningIcon from "@mui/icons-material/Warning";

import type { JSX } from "react";
import BulkSign from "~/assets/bulkSign";
import DatabaseIcon from "~/assets/DatabaseIcon";
import GPUIcon from "~/assets/GPUIcon";
import RAMIcon from "~/assets/RAMIcon";
import { createSvgIconAsset } from "~/assets/createSvgIconAsset";
import { GraphDown, GraphUp } from "~/assets/GraphDown";
import { getRadioIconType } from "~/helpers/radioHelper";

import { Badge, CircularProgress, LinearProgress, colors , type MuiSvgIconProps as SvgIconProps, RadioPin } from '@h9/ui-lib';
import { AddLocation, AssignmentOutlined } from "@mui/icons-material"
const { grey, red, lightBlue, orange, blue, yellow } = colors;

const DatabaseSvgIcon = createSvgIconAsset(DatabaseIcon);
const GPUSvgIcon = createSvgIconAsset(GPUIcon);
const RAMSvgIcon = createSvgIconAsset(RAMIcon);

type IconProp = {
  color?: string;
  size?: number;
  height?: number;
  width?: number;
}
type ImgProp = {
  height?: number;
  width?: number;
}

const style = {
  marginBottom: 2,
};

/** Matches former BaseBadge (radio SIM/Beta overlays on CellTower). */
const radioIconBadgeSx = {
  "& .MuiBadge-badge": {
    right: 8,
    top: 21,
    border: "2px solid #026950",
    padding: "0px 4px 0px 4px",
    backgroundColor: "rgb(232,238,237)",
    height: 12,
    width: 12,
    color: "#026950",
    fontSize: 6,
  },
};

/** Matches former StyledBadge (eSIM “e” on SimCard). */
const esimBadgeSx = {
  "& .MuiBadge-badge": {
    right: 19,
    top: 14,
    border: "2px solid #026950",
    padding: "0 4px",
    backgroundColor: "rgb(232,238,237)",
    height: 18,
    width: 10,
    color: "#026950",
  },
};

export const Images = {
  H9NLogo: "images/highway9networks.png",
  GCP: "images/Google-cloud-v2.svg.png",
  AWS: "images/AWS_Cloud.svg.png",
  AZURE: "images/azure.png",
  ORACLE: "images/oracle-cloud.svg",
  onPrem: "images/onPrem.svg",
  IndoorRadio: asset.radioIndoor,
  radioLocation: "images/celltower_red.png",
  CERTIFICATE_SELF: "images/certificate_self.png",
  QoS: "/images/QoS.png",
  deploymentDiagramOneInterface: "images/DeploymentDiagram1.png",
  bareMetalDeploymentDiagramTwoInterface: "images/BareMetalDeploymentDiagram2.png",
  PhysicalMobilityEdgeAppliance: "images/Physical_Mobility_Edge_Appliance.png",
  PhysicalMobility5GEdgeAppliance: "images/Physical_Mobility_5GEdge_Appliance.png",
  PhysicalMobility5GEdgeApplianceGwMode2Interface: "images/Physical_Mobility_5GEdge_gw_2_Appliance.png",
  PhysicalMobility5GEdgeApplianceGwMode3Interface: "images/Physical_Mobility_5GEdge_gw_3_Appliance.png",
  bareMetalInstall5g_1: "images/BareMetal_Installation_1_GW.png",
  bareMetalInstall5g_2: "images/BareMetal_Installation_2_GW.png",
  bareMetalInstall5g_1_NWExt: "images/BareMetal_Installation_1_NWExt.png",
  bareMetalInstall5g_2_NWExt: "images/BareMetal_Installation_2_NWExt.png",
  bareMetalInstall5g_3: "images/BareMetal_Installation_3_GW.png",
  bareMetalInstall5g_3_NWExt: "images/BareMetal_Installation_3_NWExt.png",
  bareMetalInstall5g_4: "images/BareMetal_Installation_4_GW.png",
  bareMetalInstallDone: "images/Installation_Complete.png",
  VMwareDeploymentDiagramTwoInterface: "images/VMwareDeploymentDiagram2.png",
  mobilityDiagram: "images/mobilityProfile-Diagram.svg",
  mobilityRSRPRange: "images/mobilityProfile-RSRPRange.svg",
  wentWrong: "images/wentWrong.png",
  cradlepoint: "images/cradlepoint.png",
  sierraWireless: "images/sierraWireless.png",
  airspan: "images/airspan.png",
  baicells: "images/baicells.png",
  multitech: "images/multitech.png",
  fortinet: "images/fortinet.png",
  digi: "images/digi.png",
  askey: "images/askey.png",
  horizon: "images/horizon.png",
  moso: "images/moso.png",
  mcp: "images/mcp.svg",
  bec: "images/BEC.png",
  peplink: "images/peplink.png",
  teltonika: "images/teltonika.png",
  connectedDevices: asset.connectedDevices,
  coverageArea: asset.locationMapMarker,
  averageUtilization: asset.networkUtilization,
  highway9Logo: asset.highway9Logo,
  BareMetal4G_ProxyConfiguration: "images/BareMetal4G_ProxyConfiguration.png",
  BareMetal4G_EdgeConfiguration_GM: "images/BareMetal4G_EdgeConfiguration_GM.png",
  BareMetal4G_EdgePreRequisitesCheck: "images/BareMetal4G_EdgePreRequisitesCheck.png",
  BareMetal4G_EdgePreRequisitesCheck_NWExt: "images/BareMetal4G_EdgePreRequisitesCheck_NWExt.png",
  BareMetal4G_EdgeConfiguration_NM: "images/BareMetal4G_EdgeConfiguration_NM.png",
  BareMetal4G_EdgeConfiguration_NM2: "images/BareMetal4G_EdgeConfiguration_NM_2.png",
  BareMetal4G_VMC_Configuration: "images/BareMetal4G_VMC_Configuration.png",
  BareMetal4G_DHCP_IP_Configuration_NWExT: "images/BareMetal4G_DHCP_IP_Configuration_NWExt.png",
  BareMetal4g_Static_IPConfiguration_NWExt: "images/BareMetal4g_Static_IPConfiguration(NWExt).png",
  BareMetal4g_Static_IP_Configuration_Gateway: "images/BareMetal4g_Static_IP_Configuration_(Gateway).png",
  BareMetal4g_EdgeStatus_DHCP: "images/BareMetal4g_EdgeStatus_DHCP.png",
  deploymentDiagramSingleInterfaceVirtual: "/images/DeploymentDiagramSingleInterfaceVirtual.svg",
  deploymentDiagram5GBareMetal: "/images/DeploymentDiagram5GBareMetal.svg",
  deploymentDiagramPrivateCellularBareMetal: "/images/DeploymentDiagramPrivateCellularBareMetal.svg",
  deploymentDiagramCgwBareMetal: "/images/DeploymentDiagramCgwBareMetal.svg",
  deploymentDiagramCgwVirtual: "/images/DeploymentDiagramCgwVirtual.svg",
  WarehouseFactory: "/images/Warehouse-Factory.svg",
  officecampus: "/images/officecampus.svg",
  tmo: "/images/tmo.png",
  att: "/images/att.png",
  verizon: "/images/verizon.png",
};

export const Icons = {
  refreshIcon: <RefreshIcon />,
  customerSupportIcon: <HeadsetMic />,
  Datatransfer: <SwapVertIcon />,
  documentIcon: <DescriptionIcon />,
  supportIcon: <SupportAgent />,
  search: (props: SvgIconProps) => <Search {...props} />,
  plus: <Add />,
  upload: <UploadIcon titleAccess="upload" />,
  reboot: <RestartAlt titleAccess="reboot" />,
  activity: (props: SvgIconProps) => <ReceiptLongIcon {...props} />,
  scheduleOperation: (props: SvgIconProps) => <PendingActionsIcon {...props} />,
  graphAll: (props: SvgIconProps) => <AssessmentIcon {...props} />,
  forceConfig: <SettingsBackupRestoreIcon titleAccess="forceConfig" />,
  mobilityProfile: <WifiTethering titleAccess="mobilityProfile" />,
  syncProfile: <AvTimer titleAccess="syncProfile" />,
  monitoringProfile: <DvrIcon titleAccess="monitoringProfile" />,
  fullscreen: <Fullscreen titleAccess="fullscreen" />,
  floorPlan: (props: SvgIconProps) => <SatelliteIcon {...props} />,
  label: <Label titleAccess="Toggle Label" />,
  hideLabel: <LabelOff titleAccess="Toggle Label" />,
  import: <Input titleAccess="Import" />,
  play: <PlayArrowIcon titleAccess="play" />,
  stop: <StopIcon titleAccess="stop" />,
  refreshRate: <HistoryIcon titleAccess="refreshRate" />,
  sources: <FiberSmartRecordIcon />,
  filter: <FilterListIcon />,
  filterAlt: <FilterAltIcon />,
  site: <PlaceIcon fontSize="small" />,
  radioGroup: <WorkspacesIcon fontSize="small" titleAccess="RadioGroup" />,
  radioGroupIndoor: <ApartmentIcon fontSize="small" titleAccess="RadioGroupIndoor" />,
  radioGroupOutdoor: <WifiTethering fontSize="small" sx={{ mb: 0.5 }} titleAccess="RadioGroupOutdoor" />,
  cloudDownload: <CloudDownloadIcon titleAccess="cloudDownload" />,
  cloudUpload: <CloudUploadRounded titleAccess="cloudUpload" />,
  sas: <Topic titleAccess="" />,
  download: <FileDownloadIcon titleAccess="download" />,
  downloadReady: <FileDownloadDoneIcon titleAccess="downloadReady" />,
  password: <PasswordIcon titleAccess="password" />,
  editIcon: <EditIcon titleAccess="Edit" />,
  notesIcon: <NotesIcon />,
  error: (props: SvgIconProps) => (<ErrorIcon  {...props} />),
  orderManagement: <ShoppingCartRounded />,
  serviceInstance: <GroupWorkRounded />,
  userIcon: <AccountCircleRounded style={{ color: "#616161", ...style }} titleAccess="User" />,
  code: <CodeOutlined />,
  userManagement: <PeopleAltOutlined />,
  cloudDashboard: <EqualizerRounded />,
  settings: <TuneRounded titleAccess="Settings" />,
  profiles: <DatasetOutlined titleAccess="Profiles" />,
  menuIcon: <MenuIcon titleAccess="Menu" />,
  edge: (props: SvgIconProps) => <DeviceHub style={style} titleAccess="Edge" {...props} />,
  deviceHub: <DeviceHub color="primary" sx={{ width: "30px", height: "33px" }} titleAccess="DeviceHub" />,
  location: <LocationOnRounded style={style} titleAccess="location" />,
  compass: <ExploreOutlined style={style} titleAccess="Compass" />,
  altitude: <VerticalAlignTop style={style} titleAccess="Altitude" />,
  AI: (props: SvgIconProps) => <Dataset {...props} />,
  AICluster: (props: SvgIconProps) => <StorageIcon {...props} />,
  AINode: (props: SvgIconProps) => <DeveloperBoardIcon {...props} />,
  AIManagedService: (props: SvgIconProps) => <BuildCircleOutlined {...props} />,

  /** App type icons for AI Infrastructure (AppChip, DetailPanel) */
  AIAppType: {
    LLM: (props: SvgIconProps) => <PsychologyIcon {...props} />,
    MCP_SERVER: ({ width = 24, height = 24 }: IconProp) => <img src={Images.mcp} style={{ width, height }} />,
    RAN_CU: (props: SvgIconProps) => <SettingsInputAntenna {...props} />,
    RAN_DU: (props: SvgIconProps) => <CellTowerIcon {...props} />,
    CAMERA: (props: SvgIconProps) => <VideocamIcon {...props} />,
    GENERAL_PURPOSE: (props: SvgIconProps) => <ExtensionIcon {...props} />,
    _DEFAULT: (props: SvgIconProps) => <MiscellaneousServicesIcon {...props} />,
  },
  /** Category icons for AI App Catalog (marketplace sidebar, chips) */
  AICategory: {
    LLM: (props: SvgIconProps) => <PsychologyIcon {...props} />,
    Video: (props: SvgIconProps) => <VideocamIcon {...props} />,
    Networking: (props: SvgIconProps) => <AccountTree {...props} />,
    Security: (props: SvgIconProps) => <SecurityIcon {...props} />,
    Analytics: (props: SvgIconProps) => <ShowChartIcon {...props} />,
    Storage: (props: SvgIconProps) => <DatabaseSvgIcon {...props} />,
    Compute: (props: SvgIconProps) => <Memory {...props} />,
    IoT: (props: SvgIconProps) => <SensorsIcon {...props} />,
    General: (props: SvgIconProps) => <CategoryIcon {...props} />,
  } as Record<string, (props: SvgIconProps) => JSX.Element>,
  /** Hardware resource icons for AI Infrastructure (cluster cards, node/storage) */
  AIHardware: {
    NodePool: (props: SvgIconProps) => <Folder {...props} />,
    Node: (props: SvgIconProps) => <DeveloperBoardIcon {...props} />,
    CPU: (props: SvgIconProps) => <Memory {...props} />,
    GPU: (props: SvgIconProps) => <GPUSvgIcon {...props} />,
    Storage: (props: SvgIconProps) => <DatabaseSvgIcon {...props} />,
    RAM: (props: SvgIconProps) => <RAMSvgIcon {...props} />,
  },
  NetworkInterface: (props: SvgIconProps) => <Crop169Icon {...props} />,
  upgradeAvailable: (props: SvgIconProps) => <ArrowCircleUpTwoTone style={{ color: orange[500], ...props?.style }} {...props} />,
  notification: (props: SvgIconProps) => (<NotificationsIcon {...props} />),
  notificationOff: (props: SvgIconProps) => (<NotificationsOff {...props} />),
  teams: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.teams} style={{ width, height, marginBottom: -5 }} />),
  sumoLogic: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.sumoLogic} style={{ width, height }} />),
  solarWinds: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.solarWinds} style={{ width, height }} />),
  splunk: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.splunk} style={{ width, height }} />),
  datadog: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.datadog} style={{ width, height, marginBottom: -5 }} />),
  openTelemetry: ({ width = 20, height = 20 }: ImgProp) => (<img src={asset.openTelemetry} style={{ width, height }} />),
  IndoorRadio: ({ width = 18, height = 18 }: ImgProp) => (
    <img
      title="Radio: Indoor"
      alt="Radio Indoor"
      src={Images.IndoorRadio}
      style={{ width, height, marginBottom: "-5px" }}
    />
  ),
  MapIcon: (
    <img
      title="Map"
      about="Map"
      src={asset.map}
      style={{ width: 27, height: 33 }}
    />
  ),
  SecurityIcon: (
    <img
      title="Security"
      about="Security"
      src={asset.security}
      style={{ width: 27, height: 33 }}
    />
  ),
  OutdoorRadio: <CellTowerIcon titleAccess="Radio: Outdoor" />,
  radio: (props: SvgIconProps) => (<CellTowerIcon {...props} />),
  radioSimulated: (
    <Badge title="Radio Simulated" badgeContent={"SIM"} color="secondary" sx={radioIconBadgeSx}>
      <CellTowerIcon />
    </Badge>
  ),
  radioBeta: (
    <Badge badgeContent={"Beta!"} color="secondary" title="Radio Beta" sx={radioIconBadgeSx}>
      <CellTowerIcon />
    </Badge>
  ),
  device: (props: SvgIconProps) => (<DevicesIcon {...props} />),
  subscribers: <DevicesRounded style={style} titleAccess="Subscribers" />,
  subscriber: (props: SvgIconProps) => <PhoneIphone titleAccess="Subscriber" {...props} />,
  dashboard: <DashboardRounded />,
  monitor: <MonitorIcon sx={{ fontSize: "1rem", color: "#5B5B5B" }} />,
  APN_DNN: <AccountTree style={style} />,
  policies: <ViewInArIcon titleAccess="Policies" />,
  metrics: <TimelineIcon titleAccess="Metrics" />,
  simulators: <DeveloperMode titleAccess="Simulators" />,
  tenantAdminRole: <SupervisedUserCircleIcon titleAccess="Tenant Admin Role" />,
  operatorRole: <ManageAccountsIcon titleAccess="Operator Role" />,
  email: (props: SvgIconProps) => <EmailIcon titleAccess="Email" {...props} />,
  webhook: (props: SvgIconProps) => <Webhook titleAccess="Webhook" {...props} />,
  dataIn: <ArrowDownward />,
  dataOut: <ArrowUpward />,
  alarm: <AlarmOn titleAccess="Alarm On" />,
  alarmOff: <AlarmOff titleAccess="Alarm Off" />,
  copyIcon: <ContentCopy />,
  copyIconSmall: <ContentCopy fontSize="small" />,
  activeSubscriber: <CheckCircleOutlineIcon style={{ ...style, color: "#026950" }} titleAccess="ActiveSubscriber" />,
  inActiveSubscriber: <BlockIcon style={{ color: grey[500] }} titleAccess="InActiveSubscriber" />,
  simcard: <SimCard style={{ color: "#026950" }} />,
  esimcard: (
    <Badge badgeContent={"e"} color="secondary" sx={esimBadgeSx}>
      <SimCard style={{ color: "#026950" }} />
    </Badge>
  ),
  registered: <CheckCircleOutlineRounded style={{ color: "#026950" }} />,
  accessTimeIcon: <AccessTimeOutlined style={style} titleAccess="" />,
  goodAccessTimeIcon: <AccessTimeOutlined style={{ ...style, color: "#026950" }} titleAccess="" />,
  badAccessTimeIcon:(props: SvgIconProps) => <AccessTimeOutlined style={{ ...style, color: red[500]}} titleAccess="" {...props}/>,
  badHealth: <ErrorOutlineRounded style={{ color: red[500] }} titleAccess="Bad Health" />,
  disabledIcon: <BlockIcon style={{ ...style, color: grey[500] }} titleAccess="Disabled" />,
  cmpFailedStateIcon: <BlockIcon style={{ ...style, color: red[500] }} titleAccess="Disabled" />,
  enabledIcon: <CheckCircleOutlineIcon style={{ ...style, color: "#07695F" }} />,
  failureIcon: <CancelOutlinedIcon />,
  connected: <CheckCircle style={{ color: "#07695F" }} titleAccess="Connected" />,
  naIcon: <Circle style={{ color: grey[500] }} titleAccess="NA" />,
  logs: <MenuBookRounded titleAccess="Logs" />,
  logging: <DvrIcon titleAccess="logging" />,
  user: <PersonIcon titleAccess="User" />,
  vertDots: <MoreVertIcon />,
  edit: <EditIcon style={{ width: 20 }} titleAccess="Edit" />,
  users: <GroupIcon />,
  view: <PageviewIcon />,
  login: <LoginIcon titleAccess="Login" />,
  logout: <LogoutIcon titleAccess="Logout" />,
  delete: <DeleteIcon titleAccess="Delete" />,
  markForDeletion: <AutoDelete />,
  deleting: (
    <span style={{ display: "inline-block" }}>
      <DeleteIcon titleAccess="Deleting" />
      <LinearProgress color="error" style={{ width: 12, marginLeft: 4, marginTop: -7 }} />
    </span>
  ),
  waiting: <TimerRounded style={{ color: grey[500] }} titleAccess="waiting" />,
  operation: <SettingsIcon titleAccess="Operation" />,
  outlinedOperation: <SettingsOutlinedIcon titleAccess="Operation" />,
  SAML: <LockIcon />,
  add: <AddCircle titleAccess="Add" />,
  addAbove: <AddCircle style={{ color: lightBlue[500] }} />,
  disableAdd: <AddCircle style={{ color: grey[500] }} />,
  info: <InfoTwoTone style={{ ...style, color: lightBlue[800], marginTop: "4px" }} titleAccess="Info" />,
  inProgress: <CircularProgress size={22} thickness={5} style={{ marginBottom: -7 }} />,
  inProgressSmall: <CircularProgress size={16} thickness={3} />,
  warningIcon: (props: SvgIconProps) => <ReportProblemTwoTone {...props} />,
  graphUp: (props: IconProp) => <GraphUp {...props} />,
  graphDown: (props: IconProp) => <GraphDown {...props} />,
  warning: <ReportProblemTwoTone style={{ color: "#FFCD38" }} titleAccess="warning" />,
  unsupportedReleaseWarning: <WarningAmberRounded sx={{ color: "warning.main", fontSize: 18 }} />,
  warningOrangeColor: <ReportProblemTwoTone style={{ color: "#FF8C00" }} />,
  warningRedColor: <ReportProblemTwoTone style={{ color: "red" }} />,
  operator_role: <ManageAccountsIcon titleAccess="operator_role" />,
  tenant_admin_role: <SupervisedUserCircleIcon titleAccess="Tenant_admin_role" />,
  other_roles: <AssignmentIndIcon />,
  cancel: <CancelRounded titleAccess="cancel" style={{ color: red[500] }} />,
  active: <CheckCircle style={{ color: "#026950" }} titleAccess="Active" />,
  standby: <ModeStandbyOutlinedIcon style={{ color: grey[500] }} titleAccess="Standby" />,
  standbyGreen: <ModeStandbyOutlinedIcon style={{ color: "#026950" }} titleAccess="Standby" />,
  network: <CloudIcon titleAccess="Network" />,
  QOSProfile: <img src={Images.QoS} height="32px" alt="QoS" style={{ marginBottom: -10 }} />,
  VMZ: <SecurityIcon titleAccess="" />,
  application: <ViewInArIcon />,
  SettingsBackupRestoreIcon: <SettingsBackupRestoreIcon />,
  ArrowRightAltIcon:(props: SvgIconProps) => <ArrowRightAltIcon titleAccess="Arrow Right Alt" {...props}/>,
  DoubleArrowIcon: (props: SvgIconProps) => <DoubleArrowIcon titleAccess="Handovers" {...props} />,
  CompareArrowsIcon: (props: SvgIconProps) => <CompareArrowsIcon titleAccess="Compare Arrows" {...props} />,
  HandoverIcon: (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "1px", color: "#026950" }}>
      <CellTowerIcon style={{ fontSize: 16 }} titleAccess="Handover" />
      <CompareArrowsIcon style={{ fontSize: 16 }} />
      <CellTowerIcon style={{ fontSize: 16 }} />
    </span>
  ),
  green: <FiberManualRecord style={{ color: "#07695F" }} />,
  orange: <FiberManualRecord style={{ color: orange[500] }} />,
  grey: <FiberManualRecord style={{ color: grey[500] }} />,
  red: <ErrorIcon style={{ color: red[500] }} />,
  warningCircle: <ErrorIcon style={{ color: yellow[800] }} />,
  redSmall: <FiberManualRecord style={{ color: red[500], width: 12, height: 12, paddingBottom: 2 }} titleAccess="" />,
  orangeSmall: (
    <FiberManualRecord style={{ color: orange[500], width: 12, height: 12, paddingBottom: 2 }} titleAccess="" />
  ),
  blue: <FiberManualRecord style={{ color: blue[500] }} />,
  arrowUp: <ArrowUpward style={{ color: grey[500] }} />,
  arrowDown: <ArrowDownward style={{ color: grey[500] }} />,
  time: <AccessTime style={{ color: grey[500] }} titleAccess="Time" />,
  routed: <LanguageIcon titleAccess="" />,
  bridged: <Mediation titleAccess="" />,
  installationSteps: <MoveDown titleAccess="InstallationSteps" />,
  vpnKey: <VpnKeyIcon titleAccess="" />,
  summary: <DataObject titleAccess="Summary" />,
  uplink: <ArrowCircleUp />,
  downlink: <ArrowCircleDown />,
  any: <HeightRounded />,
  defaultView: <DevicesRounded />,
  primary: <CallSplitIcon />,
  secondary: <AltRouteIcon />,
  edgePoolIcon: <ViewStreamIcon titleAccess="Edge Pool" />,
  standaloneIcon: <Crop169Icon titleAccess="Standalone" />,
  upgrade: <OpenInBrowserRounded titleAccess="upgrade" />,
  save: <Save titleAccess="Save" />,
  discard: <DeleteForever titleAccess="Discard" />,
  sign: <AssignmentTurnedIn titleAccess="Sign" />,
  cellTower: <CellTowerIcon />,
  cellTowerGreen: <CellTowerIcon style={{ color: "#03695F" }} />,
  cellTowerRed: <CellTowerIcon style={{ color: red[500] }} />,
  cellTowerOrange: <CellTowerIcon style={{ color: orange[500] }} />,
  cellTowerBlue: <CellTowerIcon style={{ color: blue[500] }} />,
  cellTowerGrey: <CellTowerIcon style={{ color: grey[500] }} />,
  systemSettingsIcon: <SettingsSuggestIcon titleAccess="Settings" />,
  unknownIcon: <ExtensionIcon color="disabled" titleAccess="unKnown" />,
  eventsIcons: <MyLocationIcon titleAccess="Location" />,
  simulationIcon: <TapAndPlay titleAccess="Simulation" />,
  vendor: <BroadcastOnPersonalIcon titleAccess="Vendor" />,
  mapIcon: <MapIcon sx={{ width: "27px", height: "33px" }} titleAccess="Map" />,
  walkTestIcon: <HikingOutlined titleAccess="Walk Test" />,
  plusIcon: <Add titleAccess="Plus" color="primary" />,
  devicesIcon: <DevicesIcon sx={{ width: "30px", height: "33px" }} titleAccess="Devices" color="primary" />,
  closeIcon: (props: SvgIconProps) => <CloseIcon titleAccess="Close" {...props} />,
  infoIcon: (props: SvgIconProps) => <Info {...props} />,
  cradlepoint: <img alt="Cradlepoint" src={Images.cradlepoint} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  sierraWireless: <img alt="Sierra Wireless" src={Images.sierraWireless} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  baicells: <img alt="Baicells" src={Images.baicells} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  airspan: <img alt="Airspan" src={Images.airspan} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  moso: <img alt="Class-M" src={Images.moso} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  bec: <img alt="BEC" src={Images.bec} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  multitech: <img alt="MultiTech" src={Images.multitech} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  fortinet: <img alt="Fortinet" src={Images.fortinet} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  digi: <img alt="Digi" src={Images.digi} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  askey: <img alt="Askey" src={Images.askey} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  horizon: <img alt="Horizon" src={Images.horizon} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  peplink: <img alt="Peplink" src={Images.peplink} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  teltonika: <img alt="Teltonika" src={Images.teltonika} style={{ width: 16, height: 16, verticalAlign: "middle" }} />,
  settingsInputComponentIcon: <SettingsInputComponentIcon />,
  operatorDetails: <DatasetLinkedIcon />,
  adjustIcon: <AdjustIcon />,
  troubleshoot: <MonitorHeartIcon titleAccess="Troubleshoot" />,
  accessibility: <ConnectWithoutContact titleAccess="User" />,
  retainibility: <AdsClickIcon />,
  mobility: <LeakAdd />,
  integrity: <CrisisAlert />,
  availability: <TapAndPlay titleAccess="Availability" />,
  utilization: <Leaderboard />,
  aaaServer: <RememberMe />,
  hardwareInventory: <Memory titleAccess="Asset Inventory" />,
  flows: <MultipleStop titleAccess="FlowsMon" />,
  ping: <TroubleshootOutlined titleAccess="pingMon" />,
  radioMonitoring: <TroubleshootOutlined titleAccess="radioMonitoring" />,
  export: <OpenInNewIcon titleAccess="export" />,
  processing: <ManageHistoryRounded titleAccess="processing" />,
  available: <InstallMobileRoundedIcon titleAccess="available" />,
  downloaded: <SystemSecurityUpdateRoundedIcon titleAccess="downloaded" />,
  installed: <PhonelinkSetupRoundedIcon titleAccess="Installed" />,
  enabled: <SystemSecurityUpdateGoodRoundedIcon style={{ color: "#07695F" }} titleAccess="Enabled" />,
  completed: <CheckCircle style={{ color: "#07695F" }} titleAccess="Completed" />,
  deleteDeviceInfo: <AppBlockingRoundedIcon style={{ color: red[500] }} />,
  errorDeviceInfo: <DeviceUnknownRoundedIcon style={{ color: red[500] }} />,
  unknownDeviceInfo: <DeviceUnknownRoundedIcon sx={{ color: grey[400] }} titleAccess="Unknown device" />,
  disabledDeviceInfo: <SystemSecurityUpdateWarningRoundedIcon style={{ color: orange[500] }} />,
  visibility: <Visibility titleAccess="visibility" />,
  antenna_30: <SettingsInputAntenna sx={{ fontSize: `30px !important` }} />,
  syncStatusInitialization: <UpdateOutlined style={{ color: orange[500] }} />,
  syncStatusSynchronized: <AlarmOn style={{ color: "#03695F" }} />,
  syncStatusHoldOver: <AlarmOn style={{ color: orange[500] }} />,
  syncStatusHoldOverExpired: <AlarmOn style={{ color: red[500] }} />,
  syncStatusNA: <AlarmOn style={{ color: red[500] }} />,
  certificate: <WorkspacePremiumIcon />,
  supportChannel: <SupportIcon />,
  system: <Engineering />,
  accessConfig: <AddToHomeScreen />,
  general: <Tune />,
  insights: (props: SvgIconProps) => <TipsAndUpdates {...props} />,
  insightsInactive: (props: SvgIconProps) => <TipsAndUpdatesOutlined {...props} />,
  InsertChartIcon: <InsertChartOutlinedIcon />,
  heatMap: <Gradient titleAccess="Heat Map" />,
  stackedBarChart: <StackedBarChart titleAccess="Chart" />,
  tableView: <TableView titleAccess="Table" />,
  clock: (props: SvgIconProps) => <AccessTime {...props} />,
  dhcpHealth: <HealingIcon />,
  templateLineChart: <ShowChartIcon />,
  connectedDevices: <img src={Images.connectedDevices} alt={`${text.totalConnectedDevicesTitle} image`} />,
  coverageArea: <img src={Images.coverageArea} alt={`${text.coverageAreaTitle} image`} />,
  averageUtilization: <img src={Images.averageUtilization} alt={`${text.averageUtilizationTitle} image`} />,
  apiDocs: <CodeIcon />,
  license: <DescriptionIcon />,
  WhitelistPolicy: <PolicyOutlinedIcon />,
  DragIndicator: <DragIndicator style={{ color: 'black' }} />,
  circle: <LensOutlinedIcon />,
  information: <Info />,
  attributes: (props: SvgIconProps) => <LocalOfferOutlined {...props} />,
  NavigateNextIcon: (props: SvgIconProps) => <NavigateNextIcon {...props} />,
  InfoOutlined: (props: SvgIconProps) => <InfoOutlined {...props} />,
  EmergencyIcon: ({ color, size }: IconProp) => <EmergencySvg color={color} size={size} />,
  AddCircle: (props: SvgIconProps) => <AddCircle {...props} />,
  IndoorRadioGroup: ({ size }: IconProp) => <IndoorRadioGroup size={size} />,
  OutdoorRadioGroup: ({ size }: IconProp) => <OutdoorRadioGroup size={size} />,
  DeleteIcon: (props: SvgIconProps) => <DeleteIcon {...props} />,
  AccountTree: (props: SvgIconProps) => <AccountTree {...props} />,
  CheckCircleOutlineIcon: (props: SvgIconProps) => <CheckCircleOutlineIcon {...props} />,
  CancelRounded: (props: SvgIconProps) => <CancelRounded {...props} />,
  HeightRounded: (props: SvgIconProps) => <HeightRounded {...props} />,
  ArrowCircleUp: (props: SvgIconProps) => <ArrowCircleUp {...props} />,
  ArrowCircleDown: (props: SvgIconProps) => <ArrowCircleDown {...props} />,
  ViewInArIcon: (props: SvgIconProps) => <ViewInArIcon {...props} />,
  DevicesRounded: (props: SvgIconProps) => <DevicesRounded {...props} />,
  Add: (props: SvgIconProps) => <Add {...props} />,
  QoSIcon: (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => <img src={Images.QoS} alt="QoS" {...props} />,
  DevicesRoundedIcon: (props: SvgIconProps) => <DevicesRounded {...props} />,
  PhoneAndroidOutlinedIcon: (props: SvgIconProps) => <PhoneAndroidOutlinedIcon {...props} />,
  SimCardOutlinedIcon: (props: SvgIconProps) => <SimCardOutlinedIcon {...props} />,
  DoneIcon: (props: SvgIconProps) => <DoneIcon {...props} />,
  CancelOutlinedIcon: (props: SvgIconProps) => <CancelOutlinedIcon {...props} />,
  UpdateOutlinedIcon: (props: SvgIconProps) => <UpdateOutlined {...props} />,
  OutputIcon: (props: SvgIconProps) => <OutputIcon {...props} />,
  OpenInNewIcon: (props: SvgIconProps) => <OpenInNewIcon {...props} />,
  KeyboardArrowDownIcon: (props: SvgIconProps) => <KeyboardArrowDownIcon {...props} />,
  KeyboardArrowUpIcon: (props: SvgIconProps) => <KeyboardArrowUpIcon {...props} />,
  MobilityEdge: ({ size }: IconProp) => <MobilityEdge size={size} />,
  Network: ({ size }: IconProp) => <Network size={size} />,
  NetworkArrowRight: (props: IconProp) => <NetworkArrowRight {...props} />,
  DeviceHubIcon: (props: SvgIconProps) => <DeviceHub {...props} />,
  CheckCircleIcon: (props: SvgIconProps) => <CheckCircle {...props} />,
  ArrowForwardIos: (props: SvgIconProps) => <ArrowForwardIos {...props} />,
  CheckCircleOverflown: ({ size }: IconProp) => <CheckCircleOverflown size={size} />,
  DownloadInstall: ({ size }: IconProp) => <DownloadInstall size={size} />,
  AddCircleOutlineIcon: (props: SvgIconProps) => <AddCircleOutlineIcon {...props} />,
  Help: (props: SvgIconProps) => <Help {...props} />,
  CheckIcon: (props: SvgIconProps) => <CheckIcon {...props} />,
  ReportIcon: (props: SvgIconProps) => <ReportIcon {...props} />,
  WarningIcon: (props: SvgIconProps) => <WarningIcon {...props} />,
  manualSwitchOver: <ImportExportOutlinedIcon titleAccess="Manual Switch Over" />,
  MoveUpIcon: (props: SvgIconProps) => <MoveUp {...props} />,
  ChannelPlaner: (props: SvgIconProps) => <OnlinePrediction {...props} />,
  home: (props: SvgIconProps) => <Home {...props} />,
  AboutRadioGeneral: (props: SvgIconProps) => <AboutRadioGeneral {...props} />,
  AboutRadioCellNFrequency: (props: ImgProp) => <AboutRadioCellNFrequency {...props} />,
  AboutRadioSAS: (props: SvgIconProps) => <AboutRadioSAS {...props} />,
  AboutRadioMobility: (props: SvgIconProps) => <AboutRadioMobility {...props} />,
  AboutRadioAdvanced: (props: SvgIconProps) => <AboutRadioAdvanced {...props} />,
  clearIcon: (props: SvgIconProps) => <DeleteSweep {...props} />,
  installationInfo: (props: SvgIconProps) => <HomeRepairService {...props} />,
  BulkSign: ({ size }: IconProp) => <BulkSign size={size} />,
  Web: (props: SvgIconProps) => <Public {...props} />,
  Dns: (props: SvgIconProps) => <DnsOutlined {...props} />,
  TAC: <TrackChangesOutlined />,
  NetworkName: <SensorsSharp />,
  tmo: <img src={Images.tmo} alt="T-Mobile" height="12px" />,
  att: <img src={Images.att} alt="AT&T" height="16px" />,
  verizon: <img src={Images.verizon} alt="Verizon" height="16px" />,
  Satellite: (props: SvgIconProps) => <SatelliteIconAlt {...props} />,
  SiteImport: (props: SvgIconProps) => <AddLocation {...props} />,
  ExportCiq: (props: SvgIconProps) => <AssignmentOutlined />,
};

export const withLoading = (Icon: JSX.Element) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <LinearProgress style={{ position: "absolute", bottom: "-5px", left: "0", width: "18px" }} />
    </div>
  );
};

export const withWaiting = (Icon: JSX.Element, color = "#fc8d26", titleAccess?: string) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}

      <TimerIcon
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        titleAccess={titleAccess || "Time"}
      />
    </div>
  );
};

export const withMaintenance = (Icon: JSX.Element, color = "grey", titleAccess?: string) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}

      <BuildIcon
        style={{ position: "absolute", top: "-6px", right: "-4px", fontSize: "small", color: color }}
        titleAccess={titleAccess || "Under Maintenance"}
      />
    </div>
  );
};

export const withError = (Icon: JSX.Element, color = red[500]) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <ErrorIcon
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        titleAccess="Error"
      />
    </div>
  );
};

export const withDelete = (Icon: JSX.Element, color = red[500] as string) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <AutoDelete
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        titleAccess="AutoDelete"
      />
    </div>
  );
};

/**
 *
 * @param {JSX.Element} Icon
 * @param {string } state  DEPLOYED | DEPLOYING | NOT_DEPLOYED | FAILED | MARKED_FOR_REBOOT | MARKED_FOR_DELETE | DELETING | MARKED_FOR_UPDATE | WAITING | UPDATING
 * @returns {JSX.Element}
 * @example
 *
 * const Icon = withState(<DeviceIcontitleAccess=""/>, DEPLOYED)
 */
export const withState = (Icon: JSX.Element, state: OBJ_STATUS | OperationalState) => {
  switch (state) {
    case OBJ_STATUS.DEPLOYING:
    case OBJ_STATUS.MARKED_FOR_REBOOT:
    case OBJ_STATUS.AUTO_CONFIGURING:
    case OBJ_STATUS.MARKED_FOR_AUTO_CONFIG:
    case OBJ_STATUS.CONFIGURING:
      return withLoading(Icon);
    case OBJ_STATUS.FAILED:
      return withError(Icon);

    case OBJ_STATUS.MARKED_FOR_DELETE:
      return withDelete(Icon, "gray");
    case OBJ_STATUS.DELETING:
      return withDelete(Icon);

    case OBJ_STATUS.NOT_DEPLOYED:
      return withWaiting(Icon, "gray");

    case OBJ_STATUS.MARKED_FOR_UPDATE:
    case OBJ_STATUS.WAITING:
    case OBJ_STATUS.UPDATING:
    case OBJ_STATUS.AUTO_REGISTERING:
    case OBJ_STATUS.MARKED_FOR_DISABLE:
      return withWaiting(Icon, "#fc8d26", state);

    case OperationalState.UNDER_MAINTENANCE:
      return withMaintenance(Icon);

    case OBJ_STATUS.DEPLOYED:
    default:
      return Icon;
  }
};

export const StatusIcon = (status: OBJ_STATUS) => {
  switch (status) {
    case OBJ_STATUS.DEPLOYED:
    case OBJ_STATUS.REGISTERED:
    case OBJ_STATUS.UPDATED:
      return Icons.registered;

    case OBJ_STATUS.FAILED:
    case OBJ_STATUS.REJECTED:
      return Icons.error;
    case OBJ_STATUS.MARKED_FOR_DELETE:
      return Icons.delete;
    case OBJ_STATUS.DELETING:
      return Icons.deleting;
    case OBJ_STATUS.NOT_DEPLOYED:
    case OBJ_STATUS.MARKED_FOR_UPDATE:
    case OBJ_STATUS.AKNOWLEDGED:
      return Icons.waiting
    case OBJ_STATUS.WAITING:
    case OBJ_STATUS.UPDATING:
    case OBJ_STATUS.CREATING:
      return Icons.inProgress;
    default:
      return Icons.waiting;
  }
}

function isRadio(data: Radio | Hardware | undefined): data is Radio {
  return (data as Radio).type === "radio";
}

export function getRadioIcon(data?: Radio | Hardware, hideLabel = false) {
  if (!data) return Icons.OutdoorRadio;
  if (isRadio(data)) {
    // Radio
    if (data.isSimulatedRadio) {
      return Icons.radioSimulated;
    }
    return (
      <RadioPin
        type={getRadioIconType(data)}
        parameters={{
          angle: 0,
          beamwidth: 0,
          gain: 0,
          health: "UNKNOWN",
          channelColor: "#D3D3D3",
          network: hideLabel ? "" : data.technology,
        }}
        isBorderRadio={data.isBorderRadio ?? false}
        showSector={false}
        size="radioTable"
        forRadioTable
      />
    );
  } else {
    // Hardware
    if (data.modelType === "Indoor" || data.modelType === undefined) {
      return <Icons.IndoorRadio />;
    }
    return Icons.OutdoorRadio;
  }
}
